import Grid, { IGridProps } from '../../../Grid';

interface IPopperActionsProps extends IGridProps {
}

const PopperActions = (props: IPopperActionsProps) => (
  <Grid
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    pt={1}
    px={2}
    pb={3}
    {...props}
  />
);

export default PopperActions;
